var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-selectbox',{attrs:{"id":"signUpTimezone","width":_vm.width,"maxHeight":200,"value":_vm.value,"items":_vm.items,"disabled":_vm.disabled,"placeholder":_vm.placeholder},on:{"input":_vm.onTimezoneChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }